import React from 'react';

import {useTranslation} from 'react-i18next';

import {Icon} from '@shared/ui/Icon';

import {Buttons, ItemButton} from './styled';

interface PaginationProps {
    currentPageIndex: number;
    disableNext: boolean;
    onPageIndexChange: (index: number) => void;
    disabled?: boolean;
}

export const SimplePagination = ({
    currentPageIndex,
    disableNext,
    onPageIndexChange,
    disabled = false,
}: PaginationProps) => {
    const {t} = useTranslation();

    return (
        <Buttons>
            <ItemButton
                disabled={disabled || currentPageIndex === 0}
                isSimple
                isActive={false}
                onClick={() => {
                    onPageIndexChange(currentPageIndex - 1);
                }}
            >
                <Icon name="arrowLeft" width={8} height={13} /> {t('components.pagination.back')}
            </ItemButton>
            <ItemButton
                isSimple
                disabled={disabled || disableNext}
                isActive={false}
                onClick={() => {
                    onPageIndexChange(currentPageIndex + 1);
                }}
            >
                {t('components.pagination.Next')} <Icon name="arrowRight" width={8} height={13} />
            </ItemButton>
        </Buttons>
    );
};
